import { ref, computed, VNode } from 'vue';
import { LegacyInspection, LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import { makeItem } from '@/ui/components/inspectionReport/items';
import ItemFactory from '@/ui/components/inspectionReport/factories/ItemFactory';
import QuestionFactory from '@/ui/components/inspectionReport/factories/QuestionFactory';
import { SelectOptions } from '@/ui/types';

const categories = ref<SelectOptions>([]);
const resource = ref<LegacyInspection | null>(null);
const isTranslationEnabled = ref(false);
const resourceIssues = computed(() => resource.value?.issues ?? []);
const inspectionPagesCount = computed(() => resource.value?.form?.items ? resource.value.form.items.length : 0);
const resourceHeaderItems = computed(() => resource.value?.form?.items
  ?.find(item => item.params?.header)?.items
  ?.map(item => item.uuid) ?? []);

const getSubItems = (items: Array<LegacyItem>): Array<VNode> => items.map(item => makeItem(item));
const getInspectionItemFactory = () => new ItemFactory();
const getInspectionQuestionFactory = () => new QuestionFactory();
const getNotRespondedAnswer = () => '-';

export function useInspectionReport() {
  return {
    categories,
    resource,
    isTranslationEnabled,
    resourceIssues,
    inspectionPagesCount,
    resourceHeaderItems,
    getSubItems,
    getInspectionItemFactory,
    getInspectionQuestionFactory,
    getNotRespondedAnswer,
  };
}
